<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {

};
</script>
<style>
#app {
  /* font-family: "宋体", "SimSun", "STSong", sans-serif; */
  font-family: Source Han Sans CN;
}

* {
  margin: 0;
  padding: 0;
}
</style>
